<template>
  <div class="burger__menu_items">
    <v-btn
        variant="text"
        color="#3254B9"
        base-color="#313743"
        class="burger__menu_items--btn"
        v-for="(item, index) in menuItems"
        :key="index"
        :active="checkActive(item)"
        @click="changeRouter(item)"
    >
          <span :class="checkActive(item) ? 'burger__menu_items--text active' : 'burger__menu_items--text'">
            {{ item.title }}
          </span>
    </v-btn>
    <v-btn
        class="btn__next"
        elevation="0"
        @click="logout(true, true)"
    >
          <span class="btn__next_text">
            {{ exitItem.title }}
          </span>
    </v-btn>
  </div>
  <LeftMenuSocial/>
</template>

<script>
import { defineComponent } from 'vue'
import pa_names from "@/modules/personal_account/routers/names"
import core_names from "@/modules/core/routers/names"
import { mapActions, mapGetters } from "vuex"
import LeftMenuSocial from "@/modules/personal_account/menus/left_menu/LeftMenuSocial.vue"

export default defineComponent({
  name: "BurgerMenu",
  components: { LeftMenuSocial },
  data () {
    return {
      menuItems: [
        { title: 'Главная страница', router: { name: pa_names.MAIN, params: {} } },
        { title: 'Партнеры', router: { name: pa_names.PARTNER.PAGE, params: {} } },
        // { icon: 'notifications', title: 'Уведомления от партнеров', router: { name: pa_names.MAIL.PAGE, params: {} } },
        // { title: 'Промокоды и акции', router: { name: pa_names.PROMO.PAGE, params: {} } },
        { title: 'Часто задаваемые вопросы', router: { name: pa_names.INFO.PAGE, params: {} } },
        { title: 'Обращения', router: { name: pa_names.FEEDBACK.PAGE, params: {} } },
      ],
      exitItem: { title: 'Выход', router: { name: core_names.MAIN, params: {} } },
      fromTopY: 0
    }
  },
  computed: {
    ...mapGetters({
      getUserStatus: 'auth/getUserStatus'
    })
  },
  methods: {
    ...mapActions({
      auth_logout: 'auth/AUTH_LOGOUT',
    }),
    checkActive: function (item) {
      const current = this.$route
      const verifiable = typeof item.router === 'object' ? item.router : { name: item.router, params: {} }
      if (verifiable.name !== current.name) { return false }
      if (Object.keys(current.params).length > Object.keys(verifiable.params).length) { return false }
      return this.checkRouteParams(Object.keys(current.params), current.params, verifiable.params)
    },
    checkRouteParams (keys, verifiable, route) {
      if (verifiable === undefined) { return false }
      if (route === undefined) { return false }
      for (const key of keys) {
        if (verifiable[key] !== route[key]) { return false }
      }
      return true
    },
    changeParam: function (item) {
      if (typeof (item) === "object") {
        return { name: item.name, params: item.params, query: item.query }
      } else {
        return { name: item }
      }
    },
    changeRouter: function (item) {
      if (this.$route.name !== item.name) {
        this.fromTopY = 0
        if (window.scrollY !== 0) {
          window.scroll({
            top: 0,
            behavior: 'smooth'
          })
        }
        this.$router.push(this.changeParam(item.router))
        this.$emit('changeRouter')
      }
    },
    logout: function (reload_page = false, redirect = true) {
      this.auth_logout({
        finalizer: () => {
          if (redirect) {
            this.changeRouter(this.exitItem)
          }
          if (reload_page) {
            document.location.reload()
          }
        },
        catcher: () => {
          if (reload_page) {
            document.location.reload()
          }
          this.changeRouter(this.exitItem)
        }
      })
    },
  },
  beforeMount () {
    this.fromTopY = window.scrollY
    document.body.style.position = 'fixed'
  },
  unmounted () {
    document.body.style.position = ''
    if (this.fromTopY !== 0) {
      window.scroll({
        top: this.fromTopY,
        behavior: 'smooth'
      })
    }
  },
  created () {
    if (this.getUserStatus) {
      if (this.getUserStatus.approve && !this.getUserStatus.agreement) {
        this.menuItems.splice(2, 0, { title: 'Промокоды и акции', router: { name: pa_names.PROMO.PAGE, params: {} } })
        this.menuItems.splice(3, 0, { icon: 'notifications', title: 'Уведомления от партнеров', router: { name: pa_names.MAIL.PAGE, params: {} } })
      }
    }
  }
})
</script>

<style scoped lang="scss">
.burger__menu_items {
  margin-top: 60px;

  &--btn {
    width: 100%;
    margin-bottom: 30px;
  }

  &--text {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #FFFFFF;

    &.active {
      border-bottom: 2px solid #ffbc00;
    }
  }
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 50px;
  width: 106px;
  height: 46px;
  background-color: #376FFE;
  border-radius: 5px;

  &:hover {
    background-color: #313743;
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

@media screen and (max-height: 560px){
  .burger__menu_items {
    margin-top: 30px;

    &--btn {
      margin-bottom: 10px;
    }

    &--text {
      font-size: 13px;
      line-height: 17px;
    }
  }
}
</style>
